import React from "react";
import { Table } from "react-bootstrap";
import NoDataFound from "../../../../components/NoDataFound";
import { FaTasks } from "react-icons/fa";

const TaskTable = ({ tasks, columns }) => (
  <>
    {tasks.length > 0 ? (
      <Table responsive>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.accessor}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tasks?.map((task) => (
            <tr key={task._id}>
              {columns.map((col) => (
                <td key={col.accessor}>
                  {col.cell ? col.cell(task) : task[col.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <NoDataFound
        icon={<FaTasks size={50} />}
        title="Tasks not found"
        description="Try Ask to add some tasks."
      />
    )}
  </>
);

export default TaskTable;
